import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  loadingScreenContainer: {
    backgroundColor: "#EDF5FB",
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  shipeeziLogo: {
    width: "65px",
    height: "45px",
  },
  "@keyframes boxAnimation": {
    from: { bottom: 0 },
    to: { bottom: 20 },
  },
  imageLogoContainer: {
    width: "92px",
    height: "92px",
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    position: "relative",
    animation: "$boxAnimation .7s cubic-bezier(1,1,1,1) infinite",
    animationDirection: "alternate",
    animationTimingFunction: "linear",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "@keyframes shadowAnimation": {
    from: { width: 120 },
    to: { width: 150 },
  },
  logoShadow: {
    background: "#e4e7ec",
    width: 120,
    height: 15,
    marginTop: 10,
    clipPath: "ellipse(40% 50%)",
    animation: "$shadowAnimation .7s cubic-bezier(1,1,1,1) infinite",
    animationDirection: "alternate",
    animationTimingFunction: "linear",
  },
  loadingText: {
    color: "#308CDB",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "24px",
    marginTop: "23px",
    "@media (max-width: 460px)": {
      textAlign: "center",
      fontSize: 20,
    },
  },
}));

export default styles;
